<template>
  <div class="section">
    <h1 class="error">404</h1>
    <div class="page">صفحه‌ای که دنبال آن بودید پیدا نشد!</div>
    <div @click="routBack" class="back-home">برگشت</div>
  </div>
</template>

<script setup>
const routBack = history.back();
</script>

<style lang="scss" scoped>
.section {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 9999;
}

.section .error {
  font-family: sans-serif;
  font-size: 150px;
  color: #00aae2;
  text-shadow: 1px 1px 1px #0096c7, 2px 2px 1px #0096c7, 3px 3px 1px #0096c7,
    4px 4px 1px #0096c7, 5px 5px 1px #0096c7, 6px 6px 1px #0096c7,
    7px 7px 1px #0096c7, 8px 8px 1px #0096c7, 25px 25px 8px rgba(0, 0, 0, 0.2);
}

.page {
  width: 80%;
  margin: 1.5rem auto 2rem;
  font-size: 20px;
  font-weight: 600;
  color: #444;
  text-align: center;
}

.back-home {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 46px;
  background: #0096c7;
  font-family: "iranyekanB", sans-serif;
  font-size: 1rem;
  color: #fff;
  border-radius: 6px;
  text-align: center;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);
  transition: all 0.1s;
  cursor: pointer;

  &:active {
    transform: scale(0.9);
  }
}
</style>
